import { InputAdornmentButton } from '@cian/ui-kit';

import * as React from 'react';

import { useFiltersContext } from '@/packages/Filters';
import { useHasUnderground } from '@/packages/Filters/shared/utils/geo';

export const UndergroundButton: React.FC = () => {
  const { onUndergroundPopupOpen } = useFiltersContext();
  const hasUnderground = useHasUnderground();

  if (!hasUnderground) {
    return null;
  }

  return (
    <InputAdornmentButton type="button" onClick={onUndergroundPopupOpen}>
      Метро
    </InputAdornmentButton>
  );
};
